import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['togglable'];

  toggle(e) {
    e.preventDefault();

    const target = this.togglableTarget;

    const { toggleClass } = target.dataset;

    target.classList.toggle(toggleClass);

    const event = new CustomEvent('toggle', {
      detail: {
        toggleClass,
        contains: target.classList.contains(toggleClass),
      },
    });

    target.dispatchEvent(event);
  }

  beforeCache() {
    const target = this.togglableTarget;

    const { toggleCacheState } = target.dataset;

    target.classList.add(toggleCacheState);
  }
}
